/**
 * Constants for WADM-compatible queryFilter shapes used by
 * SearchEWasteContainers / SearchEWasteItems.
 */

export const FILTER_TYPE = Object.freeze({
    MUST: "MUST",
    SHOULD: "SHOULD",
    MUST_NOT: "MUST_NOT"
});

export const QUERY_TYPE = Object.freeze({
    MATCH: "MATCH",
    // Case-insensitive substring match. WADM maps CONTAINS to a lowercased regexp
    // (.*<query.toLowerCase()>.*), so paired with item names stored lower-cased on
    // the 3P create path it matches partial item names without a reindex or
    // index-mapping change. Used by the WTN itemName filter.
    CONTAINS: "CONTAINS",
    GREATER_THAN_EQUAL: "GREATER_THAN_EQUAL",
    LESS_THAN_EQUAL: "LESS_THAN_EQUAL"
});

export const SORT_DIRECTION = Object.freeze({
    ASC: "ASC",
    DESC: "DESC"
});

export const QUERY_FIELD = Object.freeze({
    STATUS: "status",
    CREATED_AT: "createdAt",
    CONTAINER_ID: "containerId",
    // Item search fields (WADM item index) used by the WTN dashboard filters.
    EWC_CODE: "ewcCode",
    WTN_DOCUMENT_ID: "wtnDocumentId",
    ITEM_NAME: "itemName",
    ORDER_NUMBER: "orderNumber"
});



// WEBPACK FOOTER //
// ./src/commons/constants/WadmQueryFilter.js